<!-- notification.component.html -->
<div class="notification">
  <div class="notification-header" [ngClass]="headerClass">
    {{notification.header}}
    <button mat-icon-button (click)="removeNotification()" [attr.aria-label]="'navigation.closeNotification' | transloco" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <p>{{notification.body}}</p>
  @if (notification.order?.id) {
    <button mat-button (click)="viewOrder()" [attr.aria-label]="'navigation.viewOrder' | transloco" class="close-button">
      {{ 'common.labels.view' | transloco }}
    </button>
  }
  @if (notification.alert?.id) {
    <button mat-button (click)="viewAlert()" [attr.aria-label]="'common.labels.viewAlert' | transloco" class="close-button">
      {{ 'common.labels.view' | transloco }}
    </button>
  }
</div>
